export const placeholderTexts = {
  device: "Device",
  deviceType: "Device Type",
  visitType: "Visit Type",
  formCategories: "Form Categories",
  associatedAnatomy: "Associated Anatomy",
};
